export class Authority {
    public id?: number;
    public authority = '';
    public childAuthority: string[] = [];
    
    public static of(o: object | string): Authority {
        const a = new Authority();
        if (typeof o === 'string') {
            a.authority = o;
            return a;
        } else {
            return Object.assign(a, o);
        }
    }
    
    
}
